
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34986',
  depVersions: {
  "documents-public-ui": "static-1.34986",
  "atom": "static-1.5255",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2679",
  "client-types": "static-1.489",
  "cssUtils": "static-1.844",
  "customer-data-filters-ui": "static-1.40475",
  "customer-data-objects": "static-1.7859",
  "customer-data-property-utils": "static-1.8277",
  "documents-lib": "static-1.34991",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.353",
  "FormsCommonComponents": "static-1.86330",
  "FormUrlGenerator": "static-2.4902",
  "foundations-theming-specialty": "static-1.2334",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5773",
  "hs-test-utils": "static-1.8203",
  "hub-http": "static-1.6399",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11962",
  "HubStyleTokens": "static-2.11655",
  "I18n": "static-7.1646",
  "icons": "static-2.666",
  "jasmine-immutable": "static-1.3202",
  "jasmine-runner": "static-1.6636",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7332",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5573",
  "quartz": "static-1.7269",
  "react": "static-7.189",
  "react-dlb": "static-1.83",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16882",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5469",
  "react-virtualized": "static-2.102",
  "reference-resolvers": "static-1.8355",
  "reference-resolvers-lite": "static-1.8277",
  "reporting-data": "static-1.68269",
  "reporting-reports": "static-1.67947",
  "reporting-snowflake": "static-1.56887",
  "reporting-testing-lib": "static-1.10202",
  "reporting-visualizations": "static-1.60345",
  "reselect": "static-3.8",
  "sales-content-partitioning": "static-1.9130",
  "sanitize": "static-1.4657",
  "sanitize-text": "static-1.8325",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1924",
  "signup-constants": "static-1.19329",
  "signup-ui-url-generator": "static-2.8239",
  "StyleGuideUI": "static-3.491",
  "superstore": "static-1.4938",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4937",
  "ui-addon-form-validation": "static-1.11169",
  "ui-asset-management-lib": "static-1.11261",
  "ui-images": "static-2.1207",
  "UIComponents": "static-3.8601",
  "usage-tracker": "static-1.7531",
  "usage-tracker-container": "static-1.7521",
  "usage-tracker-core": "static-1.7381",
  "viral-links-lib": "static-1.7252",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9839",
  "foundations-components": "static-1.8282",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1047",
  "quartz-core": "static-1.6488",
  "quick-fetch": "static-1.4046",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4838",
  "ui-addon-i18n": "static-1.11328",
  "ui-addon-upgrades": "static-9.18227",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3529",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3546",
  "quartz-webpack": "static-1.3493",
  "foundations-assets": "static-1.5054",
  "foundations-theming": "static-1.4618",
  "hub-http-shared-msw-handlers": "static-1.10408",
  "hubspotter-http": "static-1.4779",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7428",
  "crm-message-bus": "static-1.43498",
  "customer-data-filters-ui-msw-helpers": "static-1.22910",
  "customer-data-objects-ui-components": "static-1.13211",
  "customer-data-reference-ui-components": "static-1.13356",
  "customer-data-ui-utilities": "static-1.10005",
  "events-data-lib": "static-1.417",
  "framework-builder-read-service-client": "static-1.4134",
  "framework-data-schema-quick-fetch": "static-1.6979",
  "framework-data-schema-resolvers": "static-1.7074",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3716",
  "inbound-db-properties-service-client": "static-1.3974",
  "multi-account-reference-resolvers": "static-1.1163",
  "onboarding-tours": "static-1.16941",
  "reporting-datasets-permissions-lib": "static-1.14203",
  "stylex": "static-1.37",
  "trellis-assets": "static-1.2292",
  "trellis-components": "static-1.2311",
  "trellis-theming": "static-1.1128",
  "ui-addon-teams": "static-1.21775",
  "quartz-auth": "static-1.944",
  "ui-business-units-lib": "static-1.9260",
  "usage-tracker-session-replay": "static-1.5217",
  "ai-components-ui-library": "static-1.9416",
  "ContentUtils": "static-1.68900",
  "customer-data-properties": "static-1.52195",
  "forms-ai-lib": "static-1.4596",
  "forms-utils-lib": "static-1.12913",
  "foundations-components-test-utils": "static-1.5765",
  "react-dnd-compat": "static-1.4794",
  "react-tinymce": "static-1.55727",
  "tinymce-config": "static-2.54853",
  "ui-gdpr-components": "static-1.10529",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3603",
  "HeadJS": "static-2.778",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3314",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.209",
  "ui-fonts": "static-1.917",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4503",
  "csstype": "static-1.50",
  "quartz-head": "static-1.934",
  "web-vitals": "static-1.9",
  "batch-promise": "static-1.1725",
  "external-options-client-types": "static-1.4254",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.944",
  "frontend-preferences-client": "static-1.8107",
  "graphql": "static-1.85",
  "persist-promise": "static-1.3882",
  "reporting-client-types": "static-1.2608",
  "apollo-stack-hubspot": "static-3.89",
  "growth-payments-core": "static-1.25916",
  "hubspot-apollo-client": "static-1.5056",
  "foundations-components-legacy": "static-1.1307",
  "quartz-routing": "static-1.699",
  "hs-story-utils": "static-1.9606",
  "react-flip-move": "static-1.74",
  "nested-table": "static-1.417",
  "timezone-utils": "static-2.5424",
  "seat-types-lib": "static-1.408",
  "react-create-root-preference": "static-1.46",
  "bend-plugin-foundations-components": "static-1.4551",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.853",
  "mobile-manifest-mixins": "static-1.552",
  "module-federation": "static-1.29",
  "quartz-test": "static-1.944",
  "quartz-tracking": "static-1.648",
  "bend-plugin-chirp-manifest": "static-1.248",
  "chirp-fetch": "static-1.2068",
  "merchandise-lib": "static-1.267",
  "purchase-motions-components": "static-1.6181",
  "salesImages": "static-1.529",
  "ts-schema": "static-1.4208",
  "bender-build-tools": "static-1.3308",
  "bend-plugin-foundations-theming": "static-1.3101",
  "restore-request-side-panel-lib": "static-1.1373",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.358",
  "pulse": "static-1.795",
  "conditional-properties-service-client": "static-1.3925",
  "crm-pipelines-api-client-types": "static-1.4266",
  "fdsr-migration-layer": "static-1.193",
  "multi-currency-client-types": "static-1.3820",
  "getting-started-shared-tasks": "static-1.18948",
  "growth-data-modal": "static-1.5723",
  "growth-onboarding-confetti": "static-1.3242",
  "growth-onboarding-next-action-utils": "static-1.2450",
  "navigation-components": "static-1.18517",
  "onboarding-tours-client": "static-1.5155",
  "onboarding-tours-utils": "static-1.1007",
  "ui-shepherd-react": "static-3.10442",
  "ui-shepherd-tracker": "static-1.7823",
  "ui-universal-auth": "static-1.9191",
  "user-context": "static-1.5291",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.33",
  "hubspotter-http-shared-msw-handlers": "static-1.10406",
  "magpie-lib": "static-1.5674",
  "navigation-messaging": "static-1.7844",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22228",
  "copilot-toolkit": "static-1.11600",
  "cms-field-types": "static-1.4995",
  "content-icons-ui": "static-1.2280",
  "integrations-lib": "static-1.16733",
  "calling-global-api": "static-1.65126",
  "calling-internal-common": "static-1.31492",
  "calling-lifecycle-internal": "static-1.66508",
  "calling-lifecycle-messages": "static-1.58802",
  "commerce-products-lib": "static-1.10236",
  "crm-links": "static-1.6494",
  "customer-data-properties-shared-msw-handlers": "static-1.9735",
  "file-manager-components": "static-1.24156",
  "formula-editor": "static-1.14577",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4345",
  "meetings-icalendar-utils-lib": "static-1.813",
  "object-builder-ui-client": "static-1.49334",
  "pipeline-validation-client-types": "static-1.4095",
  "property-value-citations": "static-1.2809",
  "smart-property-lib": "static-1.8063",
  "tiered-pricing": "static-1.1728",
  "topics-actions-lib": "static-1.330",
  "ui-addon-iframeable": "static-1.9255",
  "zustand": "static-1.79",
  "final-form": "static-1.73",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20143",
  "tinymce-themes": "static-1.56823",
  "data-token-picker": "static-1.16724",
  "hub-http-contrib": "static-1.3223",
  "interframe": "static-3.4936",
  "tinymce-data": "static-1.40938",
  "tinymce-plugins": "static-1.57967",
  "ui-addon-sales-email": "static-1.5393",
  "onboarding-scopes": "static-1.6639",
  "ui-addon-opt": "static-4.8541",
  "apollo-link-hub-http": "static-2.4832",
  "hubspot-apollo-cache": "static-1.515",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.352",
  "purchase-motions-api": "static-1.6184",
  "event-emitter": "static-1.1131",
  "bend-plugin-pulse": "static-1.298",
  "fast-json-patch": "static-1.66",
  "onboarding-data-sync-lib": "static-1.2270",
  "growth-onboarding-next-action-components": "static-1.2478",
  "user-context-client": "static-1.4731",
  "idb-keyval": "static-1.47",
  "magpie-types": "static-1.5134",
  "nest": "static-1.415",
  "reactive-lib": "static-1.904",
  "simple-logging-lib": "static-1.3229",
  "unified-auth-core-lib": "static-1.987",
  "getting-started-shared-tasks-store": "static-1.18066",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1362",
  "integrations-error-boundary-lib": "static-1.14148",
  "integrations-tracking-lib": "static-1.5787",
  "native-integrations-shared-strings": "static-1.7960",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10544",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.705",
  "calling-error-reporting": "static-1.31499",
  "shared-worker-versioning": "static-1.11217",
  "calling-usage-tracker": "static-1.6720",
  "voice-sms-access-library": "static-1.1645",
  "customer-data-tracking": "static-1.7065",
  "commerce-permissions": "static-1.955",
  "products-iframe-lib": "static-1.8369",
  "products-ui-components-shared-msw-handlers": "static-1.10790",
  "location-customization-utils-lib": "static-1.9796",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4328",
  "video-components-external": "static-1.11872",
  "video-data-lib": "static-1.35530",
  "bark-lib": "static-1.16668",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6067",
  "react-codemirror": "static-1.10814",
  "data-agent-kit": "static-1.480",
  "feedback-loader": "static-1.29632",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10491",
  "fsm": "static-1.3910",
  "policy-lib": "static-1.6966",
  "react-colorpicker": "static-2.10388",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10554",
  "FileManagerLib": "static-1.39796",
  "NamespacedHubStyle": "static-2.9179",
  "FileManagerCore": "static-1.39655",
  "content-assistance-lib": "static-1.8029",
  "layout-dnd-components": "static-1.12792",
  "layout-dnd-utils": "static-1.11767",
  "ui-addon-emoji-picker": "static-1.10064",
  "ui-brand-identity-lib": "static-1.15951",
  "InboxConnectUtils": "static-4.15304",
  "meetings-connect-utils-lib": "static-1.7786",
  "breeze-engine-core": "static-1.640",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "universal-page-editor-lib": "static-1.3192",
  "adobe-sign-auth-lib": "static-1.211",
  "ads-unified-auth-lib": "static-1.697",
  "google-sheets-integration-lib": "static-1.777",
  "microsoft-drive-integration-lib": "static-1.883",
  "surveymonkey-integration-lib": "static-1.226",
  "slack-ui-library": "static-1.10578",
  "calling-orchestration-schema": "static-1.36422",
  "sales-views-client-types": "static-1.4438",
  "crm-record-cards-service-types": "static-1.3713",
  "content-media-composition-data-lib": "static-1.12907",
  "content-media-compositions": "static-2.16914",
  "media-bridge-lib": "static-1.19240",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16102",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4687",
  "storybook-react": "static-1.36",
  "audio-components": "static-1.6184",
  "FileManagerImages": "static-1.37307",
  "video-components": "static-1.13874",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4712",
  "video-embed": "static-1.36364",
  "ui-addon-video-player": "static-1.8887",
  "ui-coaching-tips": "static-1.29068",
  "ContentData": "static-1.68975",
  "layout-data-lib": "static-1.10092",
  "social-insights-client-types": "static-1.22555",
  "outpost": "static-1.4347",
  "growth-onboarding-feedback-components": "static-1.6760",
  "advanced-menus-core": "static-1.15425",
  "advanced-menus-lib": "static-1.12320",
  "ExportDialog": "static-6.10559",
  "ui-memberships-settings-lib": "static-1.34546",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15424",
  "simple-menus-lib": "static-1.16941"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34986",
  "atom": "/atom/static-1.5255",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2679",
  "client-types": "/client-types/static-1.489",
  "cssUtils": "/cssUtils/static-1.844",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40475",
  "customer-data-objects": "/customer-data-objects/static-1.7859",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8277",
  "documents-lib": "/documents-lib/static-1.34991",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.353",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86330",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4902",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2334",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5773",
  "hs-test-utils": "/hs-test-utils/static-1.8203",
  "hub-http": "/hub-http/static-1.6399",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11962",
  "HubStyleTokens": "/HubStyleTokens/static-2.11655",
  "I18n": "/I18n/static-7.1646",
  "icons": "/icons/static-2.666",
  "jasmine-immutable": "/jasmine-immutable/static-1.3202",
  "jasmine-runner": "/jasmine-runner/static-1.6636",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7332",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5573",
  "quartz": "/quartz/static-1.7269",
  "react": "/react/static-7.189",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16882",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5469",
  "react-virtualized": "/react-virtualized/static-2.102",
  "reference-resolvers": "/reference-resolvers/static-1.8355",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8277",
  "reporting-data": "/reporting-data/static-1.68269",
  "reporting-reports": "/reporting-reports/static-1.67947",
  "reporting-snowflake": "/reporting-snowflake/static-1.56887",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10202",
  "reporting-visualizations": "/reporting-visualizations/static-1.60345",
  "reselect": "/reselect/static-3.8",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9130",
  "sanitize": "/sanitize/static-1.4657",
  "sanitize-text": "/sanitize-text/static-1.8325",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1924",
  "signup-constants": "/signup-constants/static-1.19329",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8239",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "superstore": "/superstore/static-1.4938",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4937",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11169",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11261",
  "ui-images": "/ui-images/static-2.1207",
  "UIComponents": "/UIComponents/static-3.8601",
  "usage-tracker": "/usage-tracker/static-1.7531",
  "usage-tracker-container": "/usage-tracker-container/static-1.7521",
  "usage-tracker-core": "/usage-tracker-core/static-1.7381",
  "viral-links-lib": "/viral-links-lib/static-1.7252",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9839",
  "foundations-components": "/foundations-components/static-1.8282",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1047",
  "quartz-core": "/quartz-core/static-1.6488",
  "quick-fetch": "/quick-fetch/static-1.4046",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4838",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11328",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18227",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3529",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3546",
  "quartz-webpack": "/quartz-webpack/static-1.3493",
  "foundations-assets": "/foundations-assets/static-1.5054",
  "foundations-theming": "/foundations-theming/static-1.4618",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10408",
  "hubspotter-http": "/hubspotter-http/static-1.4779",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7428",
  "crm-message-bus": "/crm-message-bus/static-1.43498",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22910",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13211",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13356",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10005",
  "events-data-lib": "/events-data-lib/static-1.417",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4134",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6979",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7074",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3716",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3974",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1163",
  "onboarding-tours": "/onboarding-tours/static-1.16941",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14203",
  "stylex": "/stylex/static-1.37",
  "trellis-assets": "/trellis-assets/static-1.2292",
  "trellis-components": "/trellis-components/static-1.2311",
  "trellis-theming": "/trellis-theming/static-1.1128",
  "ui-addon-teams": "/ui-addon-teams/static-1.21775",
  "quartz-auth": "/quartz-auth/static-1.944",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9260",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5217",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9416",
  "ContentUtils": "/ContentUtils/static-1.68900",
  "customer-data-properties": "/customer-data-properties/static-1.52195",
  "forms-ai-lib": "/forms-ai-lib/static-1.4596",
  "forms-utils-lib": "/forms-utils-lib/static-1.12913",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5765",
  "react-dnd-compat": "/react-dnd-compat/static-1.4794",
  "react-tinymce": "/react-tinymce/static-1.55727",
  "tinymce-config": "/tinymce-config/static-2.54853",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10529",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3603",
  "HeadJS": "/HeadJS/static-2.778",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3314",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.209",
  "ui-fonts": "/ui-fonts/static-1.917",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4503",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.934",
  "web-vitals": "/web-vitals/static-1.9",
  "batch-promise": "/batch-promise/static-1.1725",
  "external-options-client-types": "/external-options-client-types/static-1.4254",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.944",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8107",
  "graphql": "/graphql/static-1.85",
  "persist-promise": "/persist-promise/static-1.3882",
  "reporting-client-types": "/reporting-client-types/static-1.2608",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "growth-payments-core": "/growth-payments-core/static-1.25916",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5056",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1307",
  "quartz-routing": "/quartz-routing/static-1.699",
  "hs-story-utils": "/hs-story-utils/static-1.9606",
  "react-flip-move": "/react-flip-move/static-1.74",
  "nested-table": "/nested-table/static-1.417",
  "timezone-utils": "/timezone-utils/static-2.5424",
  "seat-types-lib": "/seat-types-lib/static-1.408",
  "react-create-root-preference": "/react-create-root-preference/static-1.46",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4551",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.853",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.552",
  "module-federation": "/module-federation/static-1.29",
  "quartz-test": "/quartz-test/static-1.944",
  "quartz-tracking": "/quartz-tracking/static-1.648",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.248",
  "chirp-fetch": "/chirp-fetch/static-1.2068",
  "merchandise-lib": "/merchandise-lib/static-1.267",
  "purchase-motions-components": "/purchase-motions-components/static-1.6181",
  "salesImages": "/salesImages/static-1.529",
  "ts-schema": "/ts-schema/static-1.4208",
  "bender-build-tools": "/bender-build-tools/static-1.3308",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3101",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1373",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.358",
  "pulse": "/pulse/static-1.795",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3925",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4266",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.193",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3820",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18948",
  "growth-data-modal": "/growth-data-modal/static-1.5723",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3242",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2450",
  "navigation-components": "/navigation-components/static-1.18517",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5155",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1007",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10442",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7823",
  "ui-universal-auth": "/ui-universal-auth/static-1.9191",
  "user-context": "/user-context/static-1.5291",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10406",
  "magpie-lib": "/magpie-lib/static-1.5674",
  "navigation-messaging": "/navigation-messaging/static-1.7844",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22228",
  "copilot-toolkit": "/copilot-toolkit/static-1.11600",
  "cms-field-types": "/cms-field-types/static-1.4995",
  "content-icons-ui": "/content-icons-ui/static-1.2280",
  "integrations-lib": "/integrations-lib/static-1.16733",
  "calling-global-api": "/calling-global-api/static-1.65126",
  "calling-internal-common": "/calling-internal-common/static-1.31492",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66508",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58802",
  "commerce-products-lib": "/commerce-products-lib/static-1.10236",
  "crm-links": "/crm-links/static-1.6494",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9735",
  "file-manager-components": "/file-manager-components/static-1.24156",
  "formula-editor": "/formula-editor/static-1.14577",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4345",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.813",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49334",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4095",
  "property-value-citations": "/property-value-citations/static-1.2809",
  "smart-property-lib": "/smart-property-lib/static-1.8063",
  "tiered-pricing": "/tiered-pricing/static-1.1728",
  "topics-actions-lib": "/topics-actions-lib/static-1.330",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9255",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.73",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20143",
  "tinymce-themes": "/tinymce-themes/static-1.56823",
  "data-token-picker": "/data-token-picker/static-1.16724",
  "hub-http-contrib": "/hub-http-contrib/static-1.3223",
  "interframe": "/interframe/static-3.4936",
  "tinymce-data": "/tinymce-data/static-1.40938",
  "tinymce-plugins": "/tinymce-plugins/static-1.57967",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5393",
  "onboarding-scopes": "/onboarding-scopes/static-1.6639",
  "ui-addon-opt": "/ui-addon-opt/static-4.8541",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4832",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.515",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.352",
  "purchase-motions-api": "/purchase-motions-api/static-1.6184",
  "event-emitter": "/event-emitter/static-1.1131",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.298",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2270",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2478",
  "user-context-client": "/user-context-client/static-1.4731",
  "idb-keyval": "/idb-keyval/static-1.47",
  "magpie-types": "/magpie-types/static-1.5134",
  "nest": "/nest/static-1.415",
  "reactive-lib": "/reactive-lib/static-1.904",
  "simple-logging-lib": "/simple-logging-lib/static-1.3229",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.987",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18066",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1362",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14148",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5787",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7960",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10544",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.705",
  "calling-error-reporting": "/calling-error-reporting/static-1.31499",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11217",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6720",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1645",
  "customer-data-tracking": "/customer-data-tracking/static-1.7065",
  "commerce-permissions": "/commerce-permissions/static-1.955",
  "products-iframe-lib": "/products-iframe-lib/static-1.8369",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10790",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9796",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4328",
  "video-components-external": "/video-components-external/static-1.11872",
  "video-data-lib": "/video-data-lib/static-1.35530",
  "bark-lib": "/bark-lib/static-1.16668",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6067",
  "react-codemirror": "/react-codemirror/static-1.10814",
  "data-agent-kit": "/data-agent-kit/static-1.480",
  "feedback-loader": "/feedback-loader/static-1.29632",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10491",
  "fsm": "/fsm/static-1.3910",
  "policy-lib": "/policy-lib/static-1.6966",
  "react-colorpicker": "/react-colorpicker/static-2.10388",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10554",
  "FileManagerLib": "/FileManagerLib/static-1.39796",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9179",
  "FileManagerCore": "/FileManagerCore/static-1.39655",
  "content-assistance-lib": "/content-assistance-lib/static-1.8029",
  "layout-dnd-components": "/layout-dnd-components/static-1.12792",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11767",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10064",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15951",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15304",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7786",
  "breeze-engine-core": "/breeze-engine-core/static-1.640",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3192",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.211",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.697",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.777",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.883",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.226",
  "slack-ui-library": "/slack-ui-library/static-1.10578",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36422",
  "sales-views-client-types": "/sales-views-client-types/static-1.4438",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3713",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12907",
  "content-media-compositions": "/content-media-compositions/static-2.16914",
  "media-bridge-lib": "/media-bridge-lib/static-1.19240",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16102",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4687",
  "storybook-react": "/storybook-react/static-1.36",
  "audio-components": "/audio-components/static-1.6184",
  "FileManagerImages": "/FileManagerImages/static-1.37307",
  "video-components": "/video-components/static-1.13874",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4712",
  "video-embed": "/video-embed/static-1.36364",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8887",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29068",
  "ContentData": "/ContentData/static-1.68975",
  "layout-data-lib": "/layout-data-lib/static-1.10092",
  "social-insights-client-types": "/social-insights-client-types/static-1.22555",
  "outpost": "/outpost/static-1.4347",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6760",
  "advanced-menus-core": "/advanced-menus-core/static-1.15425",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12320",
  "ExportDialog": "/ExportDialog/static-6.10559",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34546",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15424",
  "simple-menus-lib": "/simple-menus-lib/static-1.16941"
}
};
